import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxCheckBoxModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorMessagePipe } from '../../../../_helpers/validacion-form.service';
import { ModalFormularioEditadoComponent } from './modal-formulario-editado.component';

@NgModule({
  declarations: [ModalFormularioEditadoComponent],
  imports: [
    CommonModule,
    DxSwitchModule,
    DxTextBoxModule,
    MatDialogModule,
    ReactiveFormsModule,
    DxSelectBoxModule,
    ValidationErrorMessagePipe,
    DxTagBoxModule,
    DxCheckBoxModule,
  ],
})
export class ModalFormularioEditadoModule {}
